import React from 'react';
import Footer from './Footer-blog';
import Navbar from './Navbar';
import './all.sass';

const TemplateWrapper = ({ children }) => {
  return (
    <div>
      <Navbar />
      <div className="navbar-padding">{children}</div>
      <Footer />
    </div>
  );
};

export default TemplateWrapper;
